import React, { Component } from "react";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import getDates from "../../../shared/services/date.service";

class ControlPointMarkers extends Component {
  getIcon(color) {
    return `<?xml version="1.0" encoding="utf-8"?>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.75 1C6.16421 1 6.5 1.33579 6.5 1.75V3.6L8.22067 3.25587C9.8712 2.92576 11.5821 3.08284 13.1449 3.70797L13.3486 3.78943C14.9097 4.41389 16.628 4.53051 18.2592 4.1227C19.0165 3.93339 19.75 4.50613 19.75 5.28669V12.6537C19.75 13.298 19.3115 13.8596 18.6864 14.0159L18.472 14.0695C16.7024 14.5119 14.8385 14.3854 13.1449 13.708C11.5821 13.0828 9.8712 12.9258 8.22067 13.2559L6.5 13.6V21.75C6.5 22.1642 6.16421 22.5 5.75 22.5C5.33579 22.5 5 22.1642 5 21.75V1.75C5 1.33579 5.33579 1 5.75 1Z"
            fill="${color}" />
    </svg>`;
  }

  render() {
    const { controlPoints, onSelectControlPoint, routes, selectedRouteId } = this.props;

    let route = null;
    if (selectedRouteId !== null) {
      route = routes.filter((x) => {
        return x.id === selectedRouteId;
      })[0];
    }

    const handlePoupup = (e, controlPoint) => {
      let content = ``;

      controlPoint.routes.forEach((route) => {
        let work = "";
        let dayOff = "";

        route.workDayTimes.forEach((item) => {
          work += `<span> ${getDates.timeStringToLocalString(item)}, </span>`;
        });

        route.dayOffTimes.forEach((item) => {
          dayOff += `<span> ${getDates.timeStringToLocalString(item)}, </span>`;
        });

        content += `<div style="display: flex;"><div style="min-width: 40px;"><b>${route.title}</b></div>
        <div> <div style="margin-bottom: 5px;"><b>Будние: </b>${work}</div>  <div style="margin-bottom: 5px;"><b>Выходные: </b>${dayOff}</div></div></div>`;
      });

      e.target._popup.setContent(`<div><div style="margin-bottom: 5px;"><b>${controlPoint.title}</b></div>${content}</div>`);
      e.target._popup.update();
    };

    return (
      <div>
        {controlPoints.map((x) => {
          const color =
            route === null ||
            !route.controlPoints.some((cp) => {
              return x.id === cp.id;
            })
              ? `#1C274C${route !== null ? "aa" : ""}`
              : "red";

          const svgIcon = L.divIcon({
            html: `<div>${this.getIcon(color)}</div>`,
            className: "svg-icon",
            iconSize: [26, 26],
            iconAnchor: [6, 25],
          });

          return (
            <Marker
              key={x.id}
              position={[x.latitude, x.longitude]}
              icon={svgIcon}
              eventHandlers={{
                click: (e) => {
                  onSelectControlPoint(x.id);
                  handlePoupup(e, x);
                },
              }}
            >
              <Popup className="mapPopup" />
            </Marker>
          );
        })}
      </div>
    );
  }
}

export default withRoutes(withControlPoints(React.memo(ControlPointMarkers)));
